import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { ContactState, initialContactState } from './types'

export const contact: Module<ContactState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialContactState),
  actions,
  getters,
  mutations,
}
